export default __webpack_public_path__ + "static/media/logotype.9238993c.svg";